import ReactDOM from "react-dom";
import {defaultKcProps} from "keycloakify";
import {kcContext} from "./KcApp/kcContext";
import "./index.css";
import {KcApp} from "./KcApp";

if( kcContext === undefined ){
    throw new Error(
        "This app is a Keycloak theme" +
        "It isn't meant to be deployed outside of Keycloak"
    );
}

ReactDOM.render(
    <KcApp
        kcContext={{ ...kcContext }}
        {...{
            ...defaultKcProps,
        }}
    />,
    document.getElementById("root"),
);
